import { Checkbox, Col, Row, Typography } from "antd";
import React from "react";
import { formatDateInMMDDYYYY } from "../../helpers/date";
import UserDropDown from "../Items/user-items/UserDropDown";
import ChatIcon from "./../../graphics/svgs/chatIcon.svg";
import { formatAddress } from "../../helpers/viewUsersConstants";
const UsersTableRow: React.FC<IUsersTableRow> = ({ activeBg, user }) => {
  return (
    <Row
      style={{ background: activeBg }}
      gutter={[16, 16]}
      className="table-single-row-container"
    >
      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-customer-name">
          {user.firstName} {user.lastName}
        </Typography>
        <Typography className="users-table-customer-phone">
          {user.phoneNumber || ""}
        </Typography>
        <Typography className="users-table-customer-phone">
          {user.email}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          {/* 100 Twinge Lane apt #290 New York, NY 10001 */}
          {formatAddress(user.address)}
        </Typography>
      </Col>

      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-generic-label">
          {formatDateInMMDDYYYY(new Date(user.createdAt), true)}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-generic-label">
          {user.latestOrder
            ? formatDateInMMDDYYYY(new Date(user.latestOrder.createdAt), true)
            : "---"}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          {user.latestOrder && user.latestOrder.formulaDetails
            ? user.latestOrder.formulaDetails.activeIngredients +
              "," +
              user.latestOrder.formulaDetails.creamBase
            : "---"}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={3}>
        {user.latestOrder ? (
          <Typography className="order-prescribed-tag">
            {user.latestOrder.processingDetails.orderStatus}
          </Typography>
        ) : (
          "---"
        )}
      </Col>
      <Col className="table-cell-hrz" span={3}>
        <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
        <Checkbox />
        <UserDropDown
          userId={user._id}
          fullName={user.firstName + " " + user.lastName}
        />
        {/* <img src={ThreeDotsHrz} style={{ width: "25px", cursor: "pointer" }} /> */}
      </Col>
    </Row>
  );
};
export default UsersTableRow;
